import OperationalData from "./data";

export default function operationalDataFromJson(json) {
    return new OperationalData(
        json.sog,
        json.stw,
        json.pwr,
        json.rpm,
        json.dailyFuelConsumption
    )
}